import { NodeToolbar, Position } from '@xyflow/react';
import { Button } from '@/components/ui/button';
import { BringToFront, Copy, SendToBack, Trash2 } from 'lucide-react';

// Swatches suaves para troca rápida de cor de preenchimento.
const SWATCHES = ['#DBEAFE', '#DCFCE7', '#FEF9C3', '#FEE2E2', '#F3E8FF', '#FFFFFF'];

interface NodeQuickToolbarProps {
  nodeIds: string[];
  onDuplicate: () => void;
  onDelete: () => void;
  onColor: (color: string) => void;
  onBringToFront: () => void;
  onSendToBack: () => void;
}

/**
 * Mini-toolbar flutuante acima do nó selecionado (estilo tldraw/Miro).
 * Usa o NodeToolbar nativo do React Flow, que se posiciona sobre o nó.
 */
export function NodeQuickToolbar({
  nodeIds,
  onDuplicate,
  onDelete,
  onColor,
  onBringToFront,
  onSendToBack,
}: NodeQuickToolbarProps) {
  return (
    <NodeToolbar
      nodeId={nodeIds}
      isVisible={nodeIds.length > 0}
      position={Position.Top}
      offset={12}
    >
      <div className="flex items-center gap-1 rounded-lg border bg-background p-1 shadow-md">
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={onDuplicate}
          title="Duplicar (Ctrl+D)"
        >
          <Copy className="h-3.5 w-3.5" />
        </Button>

        <div className="flex items-center gap-0.5 px-1">
          {SWATCHES.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => onColor(c)}
              className="h-4 w-4 rounded-full border border-border transition-transform hover:scale-125"
              style={{ backgroundColor: c }}
              title={`Preencher com ${c}`}
            />
          ))}
        </div>

        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={onBringToFront}
          title="Trazer à frente"
        >
          <BringToFront className="h-3.5 w-3.5" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={onSendToBack}
          title="Enviar para trás"
        >
          <SendToBack className="h-3.5 w-3.5" />
        </Button>

        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0 text-destructive hover:text-destructive"
          onClick={onDelete}
          title="Excluir (Del)"
        >
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </div>
    </NodeToolbar>
  );
}
